import TLHClassesAPICalls from "services/TLHClassesAPICalls";

const removeStudentFromClass = async (classId, studentId) => {
  try {
    const response = await TLHClassesAPICalls.removeStudentFromClass(classId, studentId );
    console.log("Student removed successfully:", response.data);
    return response.data; // Return response if needed for further processing
  } catch (error) {
    console.error("Error removing student from class:", error);
    throw error; // Rethrow the error so it can be handled by the calling component
  }
};

export default removeStudentFromClass;
